const getImageUrl = (course) => {
  const {
    campus: {
      city: {
        url1: imageURL1, url2: imageURL2,
        country: {
          url1: imageURL3,
          url2: imageURL4,
        },
      },
    },
  } = course;

  let image = '';

  if (imageURL1) {
    image = imageURL1;
  } else if (imageURL2) {
    image = imageURL2;
  } else if (imageURL3) {
    image = imageURL3;
  } else if (imageURL4) {
    image = imageURL4;
  } else {
    image = 'https://static0.makeuseofimages.com/wordpress/wp-content/uploads/2017/08/travel-tools-destination.jpg';
  }

  return image;
};

const getCoursesInfos = async ({ id, ...params }) => {
  let courseInfo = {};
  let image = '';

  try {
    const url = `${process.env.REACT_APP_DOMAIN_URL}/${process.env.REACT_APP_COURSE_URL}/${id}?`;
    const result = await fetch(url + new URLSearchParams({ ...params }));
    const data = await result.json();
    if (data.campus.city) {
      image = getImageUrl(data);
    } else {
      image = 'https://static0.makeuseofimages.com/wordpress/wp-content/uploads/2017/08/travel-tools-destination.jpg';
    }
    const {
      course: { name },
      campus: {
        name: campusName,
        school: { name: schoolName },
      },
      duration,
      typePeriod,
      totalThisCourse: {
        onlyCourse,
        onlyCourseWithoutSR,
        onlyEnrol,
        onlyEnrolWithoutSR,
        onlyMaterial,
        onlyMaterialWithoutSR,
        valueWithoutSR,
        value: totalValue,
      },
    } = data;

    courseInfo = {
      name,
      duration,
      typePeriod,
      totalValue,
      campusName,
      schoolName,
      onlyCourse,
      onlyCourseWithoutSR,
      onlyEnrol,
      onlyEnrolWithoutSR,
      onlyMaterial,
      onlyMaterialWithoutSR,
      valueWithoutSR,
    };
  } catch (e) {
    // console.error(e);
  }

  return { ...courseInfo, image };
};

export default getCoursesInfos;
